module.exports = __webpack_public_path__ + "static/media/visa-logo_original.0fc712ed.svg";